import { useQuery } from 'react-query'
import { HeadingPages } from '../../../components/HeadingPages'
import { api } from '../../../services/api'
import { ListLayout } from './ListLayout'
import { Loader } from '../../../components/ComponentLoader/Loader'
import { Box } from '@chakra-ui/react'
import { useState } from 'react'
import { FiltroLayout } from './FiltroLayout'

export function FilaLayout() {
  const [listLayout, setListLayout] = useState([])

  const { data, isLoading } = useQuery(
    ['fila-layout'],
    async () => {
      const { data } = await api.get('/site/v2/fluxo-layout/listar-info-solicitacao-layout')

      const orderedData = data.lista.sort((a, b) => {
        if (a.prioridade && !b.prioridade) {
          return -1
        } else if (!a.prioridade && b.prioridade) {
          return 1
        } else {
          return parseInt(a.prazo_entrega) - parseInt(b.prazo_entrega)
        }
      })

      return orderedData
    },
    {
      onSuccess: (data) => {
        setListLayout(data)
      },
    }
  )

  const dataWithPosition = data?.map((item, index) => {
    return {
      ...item,
      position: index + 1,
    }
  })

  return (
    <>
      <HeadingPages name="Fila do Layout" />

      {isLoading && <Loader img={'https://imgproductioncrm.s3.us-east-2.amazonaws.com/loading-verde.gif'} />}

      <Box display="flex" flexDir="column" gap="4" alignItems="center" justifyContent="center" mb="2rem" px="4">
        <FiltroLayout setLayouts={setListLayout} layouts={dataWithPosition} />

        <ListLayout layouts={dataWithPosition} />
      </Box>
    </>
  )
}
